package com.evoapps.evoshift.domain.usecase.availability

import com.evoapps.evoshift.domain.model.WeeklyAvailabilityTemplate
import com.evoapps.evoshift.domain.repository.AvailabilityRepository

class GetWeeklyAvailabilityTemplatesUseCase(
    private val availabilityRepository: AvailabilityRepository
) {
    suspend operator fun invoke(
        userId: String,
        workplaceId: String
    ): Result<List<WeeklyAvailabilityTemplate>> {
        return availabilityRepository.getWeeklyAvailabilityTemplates(userId, workplaceId)
    }
}
